import { Button, Alert, HeadingText, Sheet } from '@paypalcorp/pp-react'
import React, { Fragment, useContext, useState } from 'react'
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react'
import apiClient from '../../api'
import PropTypes from 'prop-types'
import { MessageFormat } from '@paypalcorp/worldready'

const DeleteEntry = (props) => {
  const [deleteBtnState, setDeleteBtnState] = useState('initial')
  const [error, setError] = useState(null)
  const worldReady = useContext(WorldReadyContext)
  const apiUsername = props.toChange.apiUsername
  const successMsg = new MessageFormat(worldReady, {
    id: `thirdPartyPerm.deleteSuccess`,
  }).format({ api_username: apiUsername })

  const onDelete = async () => {
    setDeleteBtnState('processing')

    apiClient
      .post(`/deleteEntry`, { entry: props.toChange })
      .then((response) => {
        setDeleteBtnState('success')
        setError(null)
        props.closeSuccessSheet(successMsg, 'delete', response.data)
        return null
      })
      .catch((e) => {
        props.errorHandler(e, setError, worldReady, setDeleteBtnState)
      })
  }

  const renderFooter = () => {
    return (
      <div className="tppDelete_Buttons">
        <Button
          className="tpp_btn"
          id="deleteBtn"
          data-pa-click="deleteBtn"
          onClick={onDelete}
          btnState={deleteBtnState}
        >
          <Message id="thirdPartyPerm.deleteButton" />
        </Button>
      </div>
    )
  }

  return (
    <Fragment>
      <Sheet
        center
        showLogo
        isOpen={props.isDeleteOpen}
        containerClassName="tpp_sheetContainer"
        wrapperClassName="tpp_sheetWrapper"
        onCloseComplete={() => {
          props.setDeleteOpen({ type: 'delete', value: false })
          props.setToChange({})
          setError(null)
        }}
        skipFormFocus
      >
        <div className="view_content">
          {error && (
            <div className="tppError_div">
              <Alert
                type="error"
                className="tppError_alert"
                id="deleteErrorAlert"
              >
                {error}
              </Alert>
            </div>
          )}
          <HeadingText
            level={2}
            className="tppView_Heading view_heading delete_heading"
          >
            <Message id="thirdPartyPerm.deleteHeading" />
          </HeadingText>
          <p id="deleteApiUsername">
            <Message
              id="thirdPartyPerm.deleteBody"
              api_username={apiUsername}
            />
          </p>
        </div>
        {renderFooter()}
      </Sheet>
    </Fragment>
  )
}

DeleteEntry.propTypes = {
  toChange: PropTypes.object,
  isDeleteOpen: PropTypes.any,
  setDeleteOpen: PropTypes.func,
  setToChange: PropTypes.func,
  errorHandler: PropTypes.func,
  closeSuccessSheet: PropTypes.func,
}

export default DeleteEntry
